// import { useEffect, useState } from "react";
// import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
// import Button from "../../components/button/Button";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import {
//   fetchList,
//   fetchSubscriptionDataById,
//   setPlanDetails,
//   updateSubscription,
//   updateSubscriptionStatus,
// } from "../../features/subscriptionSlice";
// import {
//   basicModalShowHide,
//   largeModalShowHide,
//   setTitle,
// } from "../../features/modalSlice";
// import { BasicModal, LargeModal } from "../../components/modal/ModalUI";
// import SubscriptionDetails from "./SubscriptionDetails";
// import SubscriptionModal from "./SubscriptionModal";
// import { can } from "../../utils/permission.util";

// const Subscription = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { listData } = useSelector((state) => state.subscription);
//   const [searchText, setSearchText] = useState("");
//   const [modalTitle, setModalTitle] = useState("");
//   const [isOpenModal, setIsOpenModal] = useState(false);
//   // Pagination State
//   const [limit, setLimit] = useState(10); // Default limit
//   const [offset, setOffset] = useState(0); // Offset starts at 0

//   useEffect(() => {
//     const payload = { offset, limit, searchText: "" };
//     dispatch(fetchList(payload));
//   }, [offset, searchText]);

//   // console.log("listData >>> ", listData);

//   function itemStatusChange(id, status) {
//     let req = {
//       id: id,
//       status: status,
//     };

//     dispatch(updateSubscriptionStatus(req));
//   }

//   function editPlan(id) {
//     dispatch(
//       fetchSubscriptionDataById({
//         id: id,
//       }),
//     );
//     setIsOpenModal(true);
//     setModalTitle("Edit Subscription Plan");
//   }

//   const viewMoreDetails = (i, body) => {
//     const list = listData[i];
//     if (body === "details") {
//       dispatch(setPlanDetails(list));
//       dispatch(setTitle("Subscription Details"));
//     }
//     dispatch(largeModalShowHide());
//   };

//   const addCompany = () => {
//     // dispatch(basicModalShowHide());
//     // dispatch(setTitle("Add New Subscription Plan"));
//     setIsOpenModal(true);
//     setModalTitle("Add New Subscription Plan");
//   };

//   function closeOpenModal() {
//     setIsOpenModal(false);
//   }

//   function truncateDescription(description) {
//     if (!description) return ""; // Handle null, undefined, or empty values
//     return description.length > 100
//       ? description.substring(0, 100) + "..."
//       : description;
//   }

//   return (
//     <div id="main" className="main">
//       <Breadcrumb page="Subscription List" />
//       <section className="section">
//         <div className="row mb-3">
//           <div className="col-sm-6 col-md-12 col-lg-12 d-flex justify-content-between align-items-center">
//             <div className="d-flex align-items-center gap-2 item_list">
//               <h6 className="card-title m-0 p-0">Subscription List</h6>
//               {/* <input className='form-control' placeholder='search' type='text' name='search' value={searchText} onChange={(e) => setSearchText(e.target.value)} /> */}
//             </div>
//             {can("/subscription", "create") && (
//               <Button
//                 className="btn btn-sm btn-outline-primary me-2"
//                 title="Add Plan"
//                 onClick={() => addCompany()}
//               >
//                 <i className="fa-solid fa-plus" />
//               </Button>
//             )}
//           </div>
//         </div>
//         <table className="table table-bordered">
//           <thead>
//             <tr>
//               <th scope="col" className="text-center fs-7">
//                 Plan Name
//               </th>
//               <th scope="col" className="text-center fs-7">
//                 Description
//               </th>
//               <th scope="col" className="text-center fs-7">
//                 Monthly Cost
//               </th>
//               <th scope="col" className="text-center fs-7">
//                 Annual Cost
//               </th>
//               <th scope="col" className="text-center fs-7">
//                 Action
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {listData && listData.length
//               ? listData.map((item, i) => (
//                   <tr key={`subscriptionList-${i}`}>
//                     <td className="text-center fs-7" width="10%">
//                       {item.name}
//                     </td>
//                     <td className="text-center fs-7 align-middle">
//                       <span title={item.description}>
//                         {truncateDescription(item.description)}
//                       </span>
//                     </td>
//                     {item.id === 1 ? (
//                       <td className="text-center fs-7 align-middle">
//                         {item.price_monthly === 0 || item.price_monthly === null
//                           ? "Free"
//                           : "$ " + item.price_monthly}
//                       </td>
//                     ) : (
//                       <td className="text-center fs-7 align-middle">
//                         {item.price_monthly === 0 || item.price_monthly === null
//                           ? "--"
//                           : "$ " + item.price_monthly}
//                       </td>
//                     )}
//                     {item.id === 1 ? (
//                       <td className="text-center fs-7 align-middle">
//                         {item.price_annually === 0 ||
//                         item.price_annually === null
//                           ? "Free"
//                           : "$ " + item.price_annually}
//                       </td>
//                     ) : (
//                       <td className="text-center fs-7 align-middle">
//                         {item.price_annually === 0 ||
//                         item.price_annually === null
//                           ? "--"
//                           : "$ " + item.price_annually}
//                       </td>
//                     )}
//                     <td className="text-center fs-7 align-middle">
//                       <Button
//                         className="btn btn-outline-success btn-sm fs-7 me-2"
//                         onClick={() => viewMoreDetails(i, "details")}
//                       >
//                         <i className="fa-regular fa-eye"></i>
//                       </Button>
//                       {item?.status === 1 ? (
//                         can("/subscription", "create") && (
//                           <>
//                             <Button
//                               className="btn btn-outline-success btn-sm fs-7 me-2"
//                               onClick={() => itemStatusChange(item.id, 0)}
//                               title="Inactive Plan"
//                             >
//                               <i class="fa-solid fa-cloud-arrow-up"></i>
//                             </Button>
//                           </>
//                         )
//                       ) : (
//                         can("/subscription", "create") && (
//                           <Button
//                             className="btn btn-outline-danger btn-sm fs-7 me-2"
//                             onClick={() => itemStatusChange(item.id, 1)}
//                             title="Active Plan"
//                           >
//                             <i class="fa-solid fa-cloud-arrow-up"></i>
//                           </Button>
//                         )
//                       )}
//                       {can("/subscription", "create") && (
//                         <Button
//                           className="btn btn-outline-success btn-sm fs-7 me-2"
//                           title="Edit Subscription"
//                           onClick={() => editPlan(item.id)}
//                         >
//                           <i className="fa-solid fa-pen-to-square"></i>
//                         </Button>
//                       )}
//                       {can("/subscription", "delete") && (
//                         <>
//                           <Button
//                             className="btn btn-outline-danger btn-sm fs-7 me-2"
//                             onClick={() => itemStatusChange(item.id, 2)}
//                             title="Delete Subscription"
//                           >
//                             <i class="fa-regular fa-trash-can"></i>
//                           </Button>
//                         </>
//                       )}
//                     </td>
//                   </tr>
//                 ))
//               : null}
//           </tbody>
//         </table>
//       </section>
//       {isOpenModal && (
//         <>
//           <div
//             className="modal-backdrop fade show"
//             style={{ backgroundColor: "rgba(0, 0, 0, 0.9)" }}
//           ></div>
//           <div
//             class="modal fade show subscription-modal-width"
//             id="subscriptionModal"
//             tabindex="-1"
//             aria-modal="true"
//             role="dialog"
//             style={{ display: "block" }}
//           >
//             <div class="modal-dialog">
//               <div class="modal-content">
//                 <div class="modal-header">
//                   <h5 class="modal-title">{modalTitle}</h5>
//                   <button
//                     type="button"
//                     class="btn-close"
//                     data-bs-dismiss="modal"
//                     onClick={closeOpenModal}
//                   ></button>
//                 </div>
//                 <div class="modal-body">
//                   <SubscriptionModal closeModal={closeOpenModal} />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//       <LargeModal>
//         <SubscriptionDetails />
//       </LargeModal>
//     </div>
//   );
// };
// export default Subscription;













import { useCallback, useEffect, useState } from "react";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
import Button from "../../components/button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchList,
  fetchSubscriptionDataById,
  makeDefaultSubscription,
  setPlanDetails,
  updateSubscriptionStatus,
} from "../../features/subscriptionSlice";
import { largeModalShowHide, setTitle } from "../../features/modalSlice";
import { LargeModal } from "../../components/modal/ModalUI";
import SubscriptionDetails from "./SubscriptionDetails";
import SubscriptionModal from "./SubscriptionModal";
import { can } from "../../utils/permission.util";
import {
  RowActionButton,
  RowActionIcons,
  RowActions,
} from "../../components/data-table/RowActions";

// ✅ NEW
import SubscriptionUserMapModal from "./SubscriptionUserMapModal";

const Subscription = () => {
  const dispatch = useDispatch();
  const { listData, isMakeDefaultBtnLoad } = useSelector((state) => state.subscription);

  const searchText = "";
  const [selectedPlanType, setSelectedPlanType] = useState("all");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [modalTitle, setModalTitle] = useState("");
  const [isOpenModal, setIsOpenModal] = useState(false);

  // ✅ NEW: modal type
  const [modalType, setModalType] = useState("plan"); // plan | map
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);

  // ✅ NEW: default plan confirmation modal
  const [isDefaultModalOpen, setIsDefaultModalOpen] = useState(false);
  const [defaultTarget, setDefaultTarget] = useState(null);

  const limit = 10;
  const offset = 0;

  useEffect(() => {
    const statusPayload = selectedStatus === "all" ? "" : selectedStatus;
    const payload = { offset, limit, searchText, status: statusPayload };
    dispatch(fetchList(payload));
  }, [offset, searchText, dispatch, limit, selectedStatus]);

  function itemStatusChange(id, status) {
    dispatch(updateSubscriptionStatus({ id, status }));
  }

  function openDefaultConfirm(item) {
    const isDefault = Number(item?.defaultplan ?? 0) === 1;
    if (isDefault) return;
    setDefaultTarget(item);
    setIsDefaultModalOpen(true);
  }

  function closeDefaultConfirm() {
    setIsDefaultModalOpen(false);
    setDefaultTarget(null);
  }

  function confirmMakeDefault() {
    if (!defaultTarget?.id) return;
    dispatch(
      makeDefaultSubscription({
        id: defaultTarget.id,
        offset,
        limit,
        searchText,
      }),
    ).then((res) => {
      if (res?.payload?.success) {
        closeDefaultConfirm();
      }
    });
  }

  function editPlan(id) {
    dispatch(fetchSubscriptionDataById({ id }));
    setSelectedSubscriptionId(id);
    setModalType("plan");
    setIsOpenModal(true);
    setModalTitle("Edit Subscription Plan");
  }

  // ✅ NEW: Map modal open
  function mapUser(id) {
    setSelectedSubscriptionId(id);
    setModalType("map");
    setIsOpenModal(true);
    setModalTitle("Map Users to Subscription");
  }

  const filteredList = (listData || []).filter((item) => {
    if (selectedPlanType === "all") {
      return true;
    }
    return item.plan_type === selectedPlanType;
  });

  const viewMoreDetails = (item, body) => {
    if (body === "details") {
      dispatch(setPlanDetails(item));
      dispatch(setTitle("Subscription Details"));
    }
    dispatch(largeModalShowHide());
  };

  const addCompany = () => {
    setSelectedSubscriptionId(null);
    setModalType("plan");
    setIsOpenModal(true);
    setModalTitle("Add New Subscription Plan");
  };

  const closeOpenModal = useCallback(() => {
    setIsOpenModal(false);
    setModalType("plan");
    setSelectedSubscriptionId(null);
  }, []);

  function truncateDescription(description) {
    if (!description) return "";
    return description.length > 100
      ? description.substring(0, 100) + "..."
      : description;
  }

  return (
    <div id="main" className="main">
      <Breadcrumb page="Subscription List" />

      <section className="section">
        <div className="row mb-3">
          <div className="col-sm-6 col-md-12 col-lg-12 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2 item_list">
              <h6 className="card-title m-0 p-0">Subscription List</h6>
            </div>

            {can("/subscription", "create") && (
              <Button
                className="btn btn-sm btn-outline-primary me-2"
                title="Add Plan"
                onClick={() => addCompany()}
              >
                <i className="fa-solid fa-plus" />
              </Button>
            )}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-sm-4 col-md-3 col-lg-2">
            <label className="form-label fs-7">Plan Type</label>
            <select
              className="form-select"
              value={selectedPlanType}
              onChange={(e) => setSelectedPlanType(e.target.value)}
            >
              <option value="all">All</option>
              <option value="monthly">Monthly</option>
              <option value="yearly">Yearly</option>
            </select>
          </div>

          <div className="col-sm-4 col-md-3 col-lg-2">
            <label className="form-label fs-7">Status</label>
            <select
              className="form-select"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="all">All</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>

        <table className="table table-bordered">
          <thead>
            <tr>
              <th scope="col" className="text-center fs-7">
                Plan Name
              </th>
              <th scope="col" className="text-center fs-7">
                Plan Type
              </th>
              <th scope="col" className="text-center fs-7">
                Description
              </th>
              <th scope="col" className="text-center fs-7">
                Monthly Cost
              </th>
              <th scope="col" className="text-center fs-7">
                Annual Cost
              </th>
              <th scope="col" className="text-center fs-7">
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {filteredList.length
              ? filteredList.map((item, i) => (
                  <tr key={`subscriptionList-${i}`}>
                    <td className="text-center fs-7" width="10%">
                      {item.name}
                    </td>

                    <td className="text-center fs-7 align-middle">
                      {item.plan_type === "yearly" ? "Yearly" : "Monthly"}
                    </td>

                    <td className="text-center fs-7 align-middle">
                      <span title={item.description}>
                        {truncateDescription(item.description)}
                      </span>
                    </td>

                    {item.id === 1 ? (
                      <td className="text-center fs-7 align-middle">
                        {item.price_monthly === 0 || item.price_monthly === null
                          ? "Free"
                          : "$ " + item.price_monthly}
                      </td>
                    ) : (
                      <td className="text-center fs-7 align-middle">
                        {item.price_monthly === 0 || item.price_monthly === null
                          ? "--"
                          : "$ " + item.price_monthly}
                      </td>
                    )}

                    {item.id === 1 ? (
                      <td className="text-center fs-7 align-middle">
                        {item.price_annually === 0 ||
                        item.price_annually === null
                          ? "Free"
                          : "$ " + item.price_annually}
                      </td>
                    ) : (
                      <td className="text-center fs-7 align-middle">
                        {item.price_annually === 0 ||
                        item.price_annually === null
                          ? "--"
                          : "$ " + item.price_annually}
                      </td>
                    )}

                    <td className="text-center fs-7 align-middle">
                      <RowActions>
                        <RowActionButton
                          label="View"
                          iconClass={RowActionIcons.view}
                          variant="outline-success"
                          onClick={() => viewMoreDetails(item, "details")}
                        />
                        {item?.status === 1
                          ? can("/subscription", "create") && (
                              <RowActionButton
                                label="Unpublish"
                                iconClass={RowActionIcons.unpublish}
                                variant="outline-success"
                                onClick={() => itemStatusChange(item.id, 0)}
                              />
                            )
                          : can("/subscription", "create") && (
                              <RowActionButton
                                label="Publish to store"
                                iconClass={RowActionIcons.publish}
                                variant="outline-danger"
                                onClick={() => itemStatusChange(item.id, 1)}
                              />
                            )}
                        {can("/subscription", "create") && (
                          <RowActionButton
                            label="Edit"
                            iconClass={RowActionIcons.edit}
                            variant="outline-success"
                            onClick={() => editPlan(item.id)}
                          />
                        )}
                        {can("/subscription", "create") && (
                          <RowActionButton
                            label={
                              Number(item?.defaultplan ?? 0) === 1
                                ? "Default plan"
                                : "Set default"
                            }
                            iconClass={RowActionIcons.star}
                            variant={
                              Number(item?.defaultplan ?? 0) === 1
                                ? "warning"
                                : "outline-warning"
                            }
                            onClick={() => openDefaultConfirm(item)}
                            disabled={Number(item?.defaultplan ?? 0) === 1}
                          />
                        )}
                        {can("/subscription", "create") && (
                          <RowActionButton
                            label="Assign subscription"
                            iconClass={RowActionIcons.crown}
                            variant="outline-success"
                            onClick={() => mapUser(item.id)}
                          />
                        )}
                        {can("/subscription", "delete") && (
                          <RowActionButton
                            label="Delete"
                            iconClass={RowActionIcons.delete}
                            variant="outline-danger"
                            onClick={() => itemStatusChange(item.id, 2)}
                          />
                        )}
                      </RowActions>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </table>
      </section>

      {/* ✅ SINGLE MODAL, BODY changes by modalType (keeps your flow) */}
      {isOpenModal && (
        <>
          <div
            className="modal-backdrop fade show"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.9)" }}
          ></div>

          <div
            className="modal fade show subscription-modal-width"
            id="subscriptionModal"
            tabIndex="-1"
            aria-modal="true"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{modalTitle}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    onClick={closeOpenModal}
                  ></button>
                </div>

                <div className="modal-body">
                  {modalType === "plan" ? (
                    <SubscriptionModal closeModal={closeOpenModal} />
                  ) : (
                    <SubscriptionUserMapModal
                      closeModal={closeOpenModal}
                      subscriptionId={selectedSubscriptionId}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <LargeModal>
        <SubscriptionDetails />
      </LargeModal>

      {/* ✅ Default Plan Confirmation Modal */}
      {isDefaultModalOpen && (
        <>
          <div
            className="modal-backdrop fade show"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.9)" }}
          ></div>

          <div
            className="modal fade show subscription-modal-width"
            tabIndex="-1"
            aria-modal="true"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Default Plan</h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    onClick={closeDefaultConfirm}
                    disabled={isMakeDefaultBtnLoad}
                  ></button>
                </div>

                <div className="modal-body">
                  <p className="mb-0">
                    Make <strong>{defaultTarget?.name}</strong> the default
                    subscription plan?
                  </p>
                </div>

                <div className="modal-footer">
                  <Button
                    className="btn btn-secondary"
                    onClick={closeDefaultConfirm}
                    disabled={isMakeDefaultBtnLoad}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn btn-warning"
                    onClick={confirmMakeDefault}
                    disabled={isMakeDefaultBtnLoad}
                  >
                    Confirm
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Subscription;
